import React from "react";
import shortid from "shortid";
import "./styles/Sidebar.css";

//TODO: Add image of transaction type somewhere in the Sidebar
export default function SidebarContent(info) {
  return (
    <aside className="Sidebar">
      <h1 className="Sidebar__header">{info.Title}</h1>
      <ol className="Sidebar__element">
        {Object.keys(info).map(key => {
          return key === "Title" ? null : getInfo(info, key);
        })}
      </ol>
    </aside>
  );
}

function getInfo(info, infoKey) {
  if (!Array.isArray(info[infoKey]) && typeof info[infoKey] !== "string")
    throw new Error("Please use an Array or String in the Sidebar static data");

  return (
    <div key={shortid.generate()} className="Sidebar__element--container">
      <li className="Sidebar__element--header">{infoKey}</li>
      {typeof info[infoKey] === "string" ? (
        <p className="Sidebar__element--text">{info[infoKey]}</p>
      ) : (
        <ul className="Sidebar__element--lists">
          {info[infoKey].map(infoVal => {
            return (
              <li key={shortid.generate()} className="Sidebar__element--list">
                {infoVal}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

SidebarContent.propTypes = {
  info: React.PropTypes.object.isRequired,
  isOpen: React.PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/modules/routes/SidebarContent.js